import React from "react";
import { Link } from "react-router-dom";
import { Mail, Phone, MapPin, ArrowUpRight } from "lucide-react";
import { useI18n } from "../lib/i18n";
import { BRAND } from "../lib/brand";
import mariaPeteva from "./img/Maria Peteva Dimitrova.png";

export const Footer = () => {
  const { t } = useI18n();
  const year = new Date().getFullYear();

  return (
    <footer
      data-testid="site-footer"
      className="relative mt-32 border-t border-border bg-brand-navy text-white"
    >
      <div className="absolute inset-0 grid-mesh opacity-40 pointer-events-none" />
      <div className="relative mx-auto max-w-7xl px-6 md:px-10 lg:px-12 py-16 md:py-20 grid gap-12 md:grid-cols-12">
        <div className="md:col-span-5">
          <Link to="/" className="inline-flex items-center gap-3">
            <div className="h-11 w-11 overflow-hidden rounded-sm bg-brand-navy ring-1 ring-brand-cyan/40">
              <img src={BRAND.logo} alt="Mato Systems" className="h-full w-full object-cover" />
            </div>
            <div className="leading-tight">
              <div className="font-display text-xl font-extrabold">MATO SYSTEMS</div>
              <div className="font-mono-accent text-[10px] text-brand-cyan">
                FOUNDER-LED · BURGAS, BULGARIA
              </div>
            </div>
          </Link>
          <p className="mt-6 max-w-md text-sm text-white/70 leading-relaxed">
            {t("footer.tagline")}
          </p>
          <div className="mt-8 space-y-2 text-sm">
            <a
              href={`mailto:${BRAND.email}`}
              data-testid="footer-email-link"
              className="group inline-flex items-center gap-2 text-white/80 hover:text-brand-cyan"
            >
              <Mail className="h-4 w-4" />
              {BRAND.email}
              <ArrowUpRight className="h-3 w-3 opacity-0 -translate-x-1 transition group-hover:opacity-100 group-hover:translate-x-0" />
            </a>
            <div className="flex items-center gap-2 text-white/80">
              <Phone className="h-4 w-4" />
              {BRAND.phone}
            </div>
            <div className="flex items-center gap-2 text-white/80">
              <MapPin className="h-4 w-4" />
              {BRAND.address}
            </div>
          </div>
        </div>

        <div className="md:col-span-7 grid grid-cols-2 sm:grid-cols-3 gap-8">
          <div>
            <div className="font-mono-accent text-[10px] text-brand-cyan mb-4">
              {t("footer.sections.company")}
            </div>
            <ul className="space-y-2 text-sm">
              <li><Link to="/about" className="text-white/80 hover:text-brand-cyan" data-testid="footer-link-about">{t("nav.about")}</Link></li>
              <li><Link to="/services" className="text-white/80 hover:text-brand-cyan" data-testid="footer-link-services">{t("nav.services")}</Link></li>
              <li><Link to="/contact" className="text-white/80 hover:text-brand-cyan" data-testid="footer-link-contact">{t("nav.contact")}</Link></li>
            </ul>
          </div>
          <div>
            <div className="font-mono-accent text-[10px] text-brand-cyan mb-4">
              {t("footer.sections.services")}
            </div>
            <ul className="space-y-2 text-sm">
              <li className="text-white/80">Tier 1 Support</li>
              <li className="text-white/80">Tier 2 Support</li>
              <li className="text-white/80">Incident Handling</li>
              <li className="text-white/80">Process & Documentation</li>
              <li className="text-white/80">Jira · ServiceNow · Zendesk · Salesforce</li>
            </ul>
          </div>
          <div>
            <div className="font-mono-accent text-[10px] text-brand-cyan mb-4">
              {t("footer.sections.contact")}
            </div>
            <ul className="space-y-2 text-sm">
              <li className="text-white/80">EN · BG</li>
              <li className="text-white/80">Founder-led</li>
              <li className="text-white/80">Burgas, BG</li>
            </ul>
          </div>
        </div>
      </div>
      <div className="relative border-t border-white/10">
        <div className="mx-auto max-w-7xl px-6 md:px-10 lg:px-12 py-8 flex flex-col items-center justify-center gap-4">
          <div className="font-mono-accent text-[10px] text-white/50">
            © {year} MATO SYSTEMS · {t("footer.rights")}
          </div>
          <a href="https://mary-peteva.vercel.app/" target="_blank" rel="noopener noreferrer" className="flex flex-col items-center gap-2 hover:opacity-80 transition">
            <span className="font-mono-accent text-[10px] text-white/50">Made by</span>
            <img 
              src={mariaPeteva}
              alt="Maria Peteva Dimitrova"
              className="h-6"
            />
          </a>
          <div className="font-mono-accent text-[10px] text-white/50">
            v1.0 · EN · BG
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
